import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import {CardService} from 'app/components/cards/card.service';
@Component({
  selector: 'app-card-list',
  templateUrl: './card-list.component.html',
  styleUrls: ['./card-list.component.scss']
})
export class CardListComponent implements OnInit {
  cardList = [];
  selectedCard;
  @Input() selectedFirst = false;
  @Input() hasError = false;
  @Input() cardId = '#cardSelect';
  @Input() getCard;
  @Input() getPan;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  constructor(private cardService: CardService) { }

  ngOnInit(): void {
    this.cardList = JSON.parse(sessionStorage.getItem('ownCards'));
    if (this.cardList === null) {
      this.getOwnCard();
    } else {
      this.doStuff();
    }
  }
  doStuff() {
    if (this.cardList !== null && this.cardList.length > 0) {
      if (this.selectedFirst) {
        this.selectedCard = this.cardList[0];
        this.notifyParent.emit(this.selectedCard);
      }
      if (this.getCard !== undefined && this.getCard.uniqueId !== '') {
        this.selectedCard = this.cardList.find(el => el.uniqueId === this.getCard.uniqueId);
      }
      if (this.getPan !== undefined) {
        // this.selectedCard = this.cardList.find(el => el.pan === this.getPan);
        this.selectedCard = this.cardList.find(el =>
          (el.pan.slice(0, 7) === this.getPan.slice(0, 7)) && (el.pan.slice(15, 19) === this.getPan.slice(15, 19))
        );
        this.notifyParent.emit(this.selectedCard);
      }
      if (this.cardList.length === 1) {
        this.selectedCard = this.cardList[0];
        this.selectedFirst = true;
        this.notifyParent.emit(this.selectedCard);
      }
    }
  }
  getOwnCard() {
    this.cardService.getOwnedCards().subscribe(
      res => {
        if (res.code === 0) {
          this.cardList = res.content;
          this.getOwnCardDesign( () => {
            sessionStorage.setItem('ownCards', JSON.stringify(this.cardList));
          });
          this.doStuff();
        }
      }
    );
  }
  getOwnCardDesign(callBack) {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.cardList.length; i++) {
      const pan = this.cardList[i].pan.substr(0, 7).split('-').join('');
      const result = this.cardService.getCardDesign(pan);
      this.cardList[i] = {...result, ...this.cardList[i]};
    }
    callBack();
}
  sendParentNotification(evt) {
    document.getElementById(this.cardId).classList.add('focused');
    this.notifyParent.emit(this.selectedCard);
  }
  selectFirst() {
    if (this.cardList.length > 0 && this.selectedCard === undefined) {
      this.selectedCard = this.cardList[0];
      this.notifyParent.emit(this.selectedCard);
      document.getElementById(this.cardId).classList.add('focused');
    }
  }
}
